import { InjectionToken } from '@angular/core'

export interface SettingsFieldsRewrite {
  [source: string]: string
}
export const SETTINGS_FIELDS_REWRITE = new InjectionToken<SettingsFieldsRewrite>('SETTINGS_FIELDS_REWRITE')
